<template>
  <div class="wrapper">
    <h1>登录中</h1>
  </div>
</template>
<script>
import { wxlogin } from '@/api/base';

export default {
  name: '',
  metaInfo: { title: '' },
  created() {
    let backUrl = this.$route.query.backUrl;
    // if (!window.openId) {
    wxlogin({ backUrl: backUrl }).then(res => {
      window.location.href = res.data;
    });
    // }
  },
  methods: {
    getCodeApi() {
      //获取code
      let lurl = encodeURIComponent(`${window.location.host}'/#/index'`);
      let urlNow = encodeURIComponent(
        `https://yca.smartrecorder.xyz/prod-api/weoauth/getInfo?backUrl=${lurl}`,
      );
      let appid = 'wx6ced2d8b252a0ff2';
      // let scope='snsapi_userinfo';    //snsapi_userinfo snsapi_base   //静默授权 用户无感知
      let url =
        'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
        appid +
        '&redirect_uri=' +
        urlNow +
        '&response_type=code&scope=snsapi_userinfo#wechat_redirect';
      window.location.href = url;
    },
    getUrlKey: function(name) {
      //获取url 参数
      return (
        decodeURIComponent(
          (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [
            ,
            '',
          ])[1].replace(/\+/g, '%20'),
        ) || null
      );
    },
  },
};
</script>

<style scoped>
h1 {
  font-size: 20px;
  text-align: center;
  padding: 40px 0;
}
</style>
